import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useWorkspaceFolder } from '~/routes/projects_workspace/provider';
const ComparisonGridContext = createContext({});
const ComparisonGridProvider = (props) => {
    const { comparisonDetails } = useWorkspaceFolder();
    const [gridData, setGridData] = useState(null);
    const [showCommentsPanel, setShowCommentsPanel] = useState(false);
    const [selectedComparison, setSelectedComparison] = useState(null);
    const [showActionsControl, setShowActionsControl] = useState(false);
    const gridRef = useRef(null);
    useEffect(() => {
        if (!comparisonDetails) {
            setGridData(null);
            return;
        }
        const data = comparisonDetails
            .map(i => (Object.assign(Object.assign({}, i), { isCollapsed: true, isSelectable: true })))
            .filter(m => !m.isArchived);
        setGridData(data);
    }, [comparisonDetails]);
    const grid = {
        gridData,
        showCommentsPanel,
        selectedComparison,
        showActionsControl,
        setShowActionsControl,
        setSelectedComparison,
        setShowCommentsPanel,
        setGridData,
        gridRef,
    };
    return React.createElement(ComparisonGridContext.Provider, Object.assign({ value: grid }, props));
};
const useComparisonGrid = () => {
    const ctx = useContext(ComparisonGridContext);
    if (!ctx) {
        throw new Error('Comparison Grid Context is only usable under the ComparisonGridProvider in the tree.');
    }
    return ctx;
};
export { ComparisonGridProvider, useComparisonGrid };
